"use client";

import ScrollReveal from "@/components/common/ScrollReveal";
import React, { useState, ReactNode, useRef, useEffect } from "react";

interface DropdownProps {
  title: ReactNode;
  children: ReactNode;
  delay?: number;
}

const Dropdown: React.FC<DropdownProps> = ({ title, children, delay = 0 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState<number>(0);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isOpen ? contentRef.current.scrollHeight : 0);
    }
  }, [isOpen]);

  return (
    <ScrollReveal direction="up" delay={delay}>
      <div className="w-full">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="flex items-center w-full gap-8 rounded-lg transition-colors hover:cursor-pointer hover:opacity-90"
          style={{
            background:
              "linear-gradient(90deg, var(--color-surface-raised) 0%, var(--color-background) 100%)",
            padding: "32px",
            borderRadius: "8px",
          }}
        >
          <svg
            width="16"
            height="14"
            viewBox="0 0 16 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={`flex-shrink-0 transition-transform duration-300 ease-in-out ${
              isOpen ? "rotate-90" : ""
            }`}
          >
            <path
              d="M9.57451 13.6091L14.6914 7.94599C15.1602 7.4241 15.1602 6.577 14.6914 6.05686L9.57451 0.390433C9.10185 -0.131452 8.33682 -0.128833 7.86418 0.390433C7.39623 0.913191 7.39623 1.7568 7.86418 2.27956L10.8577 5.59191L1.25494 5.59191C0.561247 5.59191 1.27494e-05 6.21697 1.28092e-05 6.99062C1.2869e-05 7.7634 0.561247 8.38932 1.25494 8.38932L10.8757 8.38932L7.86418 11.7191C7.39623 12.241 7.39623 13.0855 7.86418 13.6074C8.33606 14.1301 9.10109 14.131 9.57451 13.6091L9.57451 13.6091Z"
              fill="var(--color-primary-600)"
            />
          </svg>

          <div className="flex-1 text-left">
            <div className="text-body-1 text-text-highlight">{title}</div>
          </div>
        </button>

        <div
          ref={contentRef}
          style={{
            maxHeight: `${height}px`,
            overflow: "hidden",
            transition: "max-height 0.3s ease-in-out, opacity 0.3s ease-in-out",
            opacity: isOpen ? 1 : 0,
          }}
        >
          <div className="mt-4">{children}</div>
        </div>
      </div>
    </ScrollReveal>
  );
};

export default Dropdown;
